import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root',
})
export class FacetStateService {
    private expandedState = new BehaviorSubject<{ [key: string]: boolean }>({});
    private showingMoreState = new BehaviorSubject<{ [key: string]: boolean }>({});

    getExpandedState(label: string) {
        return this.expandedState.value[label];
    }

    storeFacetAsExpanded(label: string) {
        const copy = { ...this.expandedState.value };
        copy[label] = true;

        this.expandedState.next(copy);
    }

    storeFacetAsColapsed(label: string) {
        const copy = { ...this.expandedState.value };
        copy[label] = false;

        this.expandedState.next(copy);
    }

    getShowMoreState(label: string) {
        return this.showingMoreState.value[label] ?? false;
    }

    storeFacetAsShowingMore(label: string) {
        const copy = { ...this.showingMoreState.value };
        copy[label] = true;

        this.showingMoreState.next(copy);
    }

    storeFacetAsShowingLess(label: string) {
        const copy = { ...this.showingMoreState.value };
        copy[label] = false;

        this.showingMoreState.next(copy);
    }
}
